
<template>
  <!-- 门磁 -->
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
        <el-form-item label="设备编号">
          <el-input
            v-model.trim="formInline.inputdeviceno"
            placeholder="请输入设备编号"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="位置">
          <el-input
            v-model.trim="formInline.location"
            placeholder="请输入绑定位置"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            plain
            class="el-icon-plus"
            @click="dialogFormVisible = true"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table
          :data="list"
          style="width: 100%"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            label="设备编号"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
            </template>
          </el-table-column>
        
          <el-table-column
            label="设备名称"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="设备描述"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="设备位置"
            min-width="150"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.location }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="老人姓名"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span
                style="margin-left: 10px; color: orange"
                v-if="
                  scope.row.oldmanName == null && scope.row.location == null
                "
                >暂未绑定</span
              >
              <span
                style="margin-left: 10px; color: red"
                v-else-if="
                  scope.row.oldmanName == null || scope.row.oldmanName == ''
                "
                >无</span
              >
              <span style="margin-left: 10px" v-else>{{
                scope.row.oldmanName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
                label="状态"
                 :show-overflow-tooltip="true"
                 align="center"
                >
                <template slot-scope="scope">
                    <span style="margin-left: 10px;color:green;"  v-if="scope.row.online==1">在线</span>
                    <span style="margin-left: 10px;color:red;"  v-else-if="scope.row.online==0">离线</span>
                    <span style="margin-left: 10px"  v-else>未知</span>
                </template>
            </el-table-column>
          <el-table-column label="操作" width="350" align="center">
            <template slot-scope="scope">
              
              <el-button type="info" size="mini" plain @click="showLogList(scope.$index, scope.row)">日志</el-button>

              <el-button
                type="primary"
                size="mini"
                plain
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                plain
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog
        title="新增设备信息"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="dangerbuttonxz"
        @close="closexz"
      >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item
            label="设备编号"
            :label-width="formLabelWidth"
            prop="xzdate"
          >
            <el-input
              v-model.trim="form.xzdate"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备名称"
            :label-width="formLabelWidth"
            prop="xzname"
          >
            <el-input
              v-model.trim="form.xzname"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备描述"
            :label-width="formLabelWidth"
            prop="xzsec"
          >
            <el-input
              v-model.trim="form.xzsec"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button
            type="primary"
            @click="submitForm('form')"
            :loading="addLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 弹出修改-->
      <el-dialog
        title="修改设备信息"
        :visible.sync="dialogFormEdit"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="dangerbuttonedit"
      >
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item
            label="设备编号"
            :label-width="formLabelWidth"
            prop="editdate"
          >
            <el-input
              disabled
              v-model.trim="formedit.editdate"
              auto-complete="off"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备名称"
            :label-width="formLabelWidth"
            prop="editname"
          >
            <el-input
              v-model.trim="formedit.editname"
              auto-complete="off"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备描述"
            :label-width="formLabelWidth"
            prop="editsec"
          >
            <el-input
              v-model.trim="formedit.editsec"
              auto-complete="off"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitFormEdit('formedit')"
            :loading="editLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>


       <!-- 设备日志 -->
       <el-dialog title="设备日志" width="70%" style="margin-top:-80px" 
        :visible.sync="logListVisible" :close-on-click-modal="false">
        <device-log-table :deviceNo="currRecordDeviceNo"></device-log-table>      
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="logListVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import deviceLogTable from "@/components/DeviceLogTable";
export default {
  components: { deviceLogTable },
  data() {
    return {
      logListVisible:false,
      currRecordDeviceNo:"",
      selectOldmanList: [], //select下拉菜单的老人集合
      addLoading: false,
      editLoading: false,
      formInline: {
      },
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      logList: [],
      logListCurrentPage: 1,
      logListTotal: 0,

      dialogFormBangdi:false,
      cascadervalue: [], //Cascader级联选择器集合的值默认为空
      optionsBed: [], //床位号的Cascader级联选择器集合
      formBangdi:{
      },
      deviceno: "",
      list: [], //返回的结果集合
      allList: [], //返回紧急按钮的集合  全部数据
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: "",
        deviceType: "",
      },
      formLabelWidth: "120px",
      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        editdate: "",
        editname: "",
        editsec: "",
      },
      rules: {
        xzdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
        ],
        xzsec: [
          { min: 1, max: 100, message: "长度在 1到 100 个字符" },
        ],
        xzname: [
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
        ],
        deviceType: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
        ]
      },
      fileFlag: false,
    };
  },
  methods: {
    showLogList(index, row) {
      this.currRecordDeviceNo = row.deviceNo;
      this.logListVisible = true;
    },
    
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 8)
          );
        }
      }
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    // 点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        this.listIndex = index; //记录索引
      //this.formedit=row;//记录数据
      this.formedit = Object.assign({}, row); //深拷贝记录
      //将对应行所对的表格值赋给input框
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editsec", row.remark);
      this.$set(this.formedit, "editname", row.deviceName);
    },

    //点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      //正则匹配规则rules
      this.$refs[datainfo].validate((valid) => {
        //判断数据是否存在
        if (valid) {
          let param = {
            id: this.formedit.id,
            remark: this.formedit.editsec,
            deviceName: this.formedit.editname,
            deviceNo: this.formedit.editdate,
          };
          this.editLoading = true;
          this.$postJson("dmc/commonDevice/edit", param)
            .then((res) => {
              this.editLoading = false;
              this.dialogFormEdit = false; //关闭修改弹窗
              this.getTableData();
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success",
                  });
                }, 300);
                console.log("修改成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }, 300);
              }
            })
            .catch((res) => {
              this.$message({
                type: "error",
                message: res.message,
              });
            });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },
    //删除
    handleDelete(index, row) {
      if (row.bindType == null) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        })
          .then(() => {
            this.$postJson("dmc/commonDevice/deleteById/" + row.id).then((res) => {
              if (res.code == 200) {
                this.getTableData();
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            });
          })
      } else {
        this.$message({
          type: "error",
          message: "该设备已经被绑定，请先解绑后再进行删除!",
        });
      }
    },
    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    addDevice() {
      let param = {
        remark: this.form.xzsec,
        deviceName: this.form.xzname,
        deviceNo: this.form.xzdate,
        deviceType: 27,
      };
      this.addLoading = true;
      this.$postJson(
        "dmc/commonDevice/add",
        param
      ).then(res => {
        if (res.code == 200) {
          this.addLoading = false;
          this.dialogFormVisible = false;
          this.$refs.form.resetFields(); //移除校验结果并重置字段值
          this.getTableData();
        } else {
          this.addLoading = false;
        }
      }).catch(err => {
        this.addLoading = false;
      });
    },
    // 新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate((valid) => {
        if (valid) {
          this.addDevice();
        } else {
          return false;
        }
      });
    },
    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno,
        deviceType: 27
      };
      this.loading = true;
      this.$postJson("dmc/commonDevice/queryDeviceStatusWithPage", param).then(
        (res) => {
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            this.loading = false;
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 800);
          }
        }
      );
    },
    //点击查询
    onSubmit() {
      this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTableData();
    },
  },
  created() {
    //组件创建完后获取数据，
    //此时 data 已经被 observed 了
    this.getTableData();
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m {
    padding: 10px 0 0 5px;
  }
}
// 修改element-ui默认的样式
.del {
  color: red !important;
}
.fangqu {
  color: green !important;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//新增的dialog
@media screen and (min-width: 1200px) {
  ::deep .dangerbuttonxz .el-dialog {
    width: 30% !important;
  }
}
//修改的dialog
@media screen and (min-width: 1200px) {
  ::deep .dangerbuttonedit .el-dialog {
    width: 30% !important;
  }
}
//绑定紧急按钮位置和房间的dialog
@media screen and (min-width: 1200px) {
  ::deep .bangdilocation .el-dialog {
    width: 30% !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 1199px) {
  ::deep .bangdilocation .el-dialog {
    width: 55% !important;
  }
}
</style>